import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

const StyledButtonBack = styled('button')`
	display: flex;
	align-items: center;
	padding: 20px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 15px;
	line-height: 18px;
	background-color: ${NewStyleColor.Grey950};
	color: ${NewStyleColor.White};
	cursor: pointer;

	svg {
		width: 16px;
		height: 16px;
		margin-right: 5px;
		fill: currentColor;
	}
`;

export {
	StyledButtonBack,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonBack/styles.ts